module.exports = __webpack_public_path__ + "img/3.20b824ab.jpg";